export enum ETenderOperationType {    
    Create,
    Update,
    Delete,
    Cancelled,
    Published
}